import Vue from 'vue';

export const CGU = {
  namespaced: true,
  state: {
    status: false,
  },
  actions: {
    setStatus({ commit, mutation }, value) {
      if (value === true) {
        mutation('open');
      } else {
        commit('close');
      }
    },
    close({ commit }) {
      commit('close');
    },
    open({ commit }) {
      commit('open');
    },
  },
  mutations: {
    open(state) {
      Vue.set(state, 'status', true);
    },
    close(state) {
      Vue.set(state, 'status', false);
    },
  },
  getters: {
    getCGUStatus: state => {
      return state.status;
    },
  },
};
